import { Injectable } from '@angular/core';
import { VerificationRequestCreate, BookingLookup } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VerificationRequestService {
    constructor(private http: HttpClient) {}

    public createVerificationRequest(verificationRequestCreate: VerificationRequestCreate): Observable<string> {
        return (this.http.post<string>('api/verificationrequests/createinternal', verificationRequestCreate));
    }

    public createVerificationRequestForMarketing(verificationRequestCreate: BookingLookup): Observable<string> {
        return this.http.post<string>('api/verificationrequests/createformarketing', verificationRequestCreate);
    }
}
